import config from 'config';

const LOAD = 'horse-racing/abc/LOAD';
const LOAD_SUCCESS = 'horse-racing/abc/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/abc/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        races: action.result,
        key: action.key
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function load(fromDate, toDate, countryGroups, letterRange) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.horseRacing.abc, {params: {fromDate, toDate, countryGroups, letterRange}}),
    key: JSON.stringify({fromDate, toDate, countryGroups, letterRange})
  };
}

export function isLoaded(state, fromDate, toDate, countryGroups, letterRange) {
  const {
    horseRacing: {
      abc: {
        loading,
        loaded,
        key
      } = {}
    } = {}
  } = state;

  const testKey = JSON.stringify({fromDate, toDate, countryGroups, letterRange});

  return !loading && loaded && key == testKey;
}

export function get(state) {
  return {races: state.horseRacing.abc.races};
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/abc.js